import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const faqs = [
    {
      question: "Qu'est-ce qui différencie Prosperian d'une agence de lead generation classique ?",
      answer: "Contrairement aux agences de leadgen qui, pour beaucoup, privilégient le volume et se contentent de générer des contacts - sans trop se soucier de leur qualité et de leur conversion, Prosperian est une suite complète qui évalue votre maturité commerciale, optimise vos fondamentaux, déploie des campagnes multi-canaux et vous accompagne jusqu'à la prise de rendez-vous qualifiés."
    },
    {
      question: "Comment fonctionne le processus de sélection pour rejoindre le programme Prosperian ?",
      answer: "Notre processus commence par un pré-scoring en ligne suivi d'un entretien approfondi avec nos experts. Nous évaluons votre capacité non seulement à générer des prospects mais aussi à les convertir efficacement."
    },
    {
      question: "Combien de temps dure le programme Prosperian ?",
      answer: "L'engagement initial est de trois mois, ce qui permet d'optimiser complètement votre dispositif de prospection et de mesurer des résultats significatifs, avant de vous déployer plus largement sur les 9 mois suivants."
    },
    {
      question: "Est-ce que Prosperian remplace mon équipe commerciale ?",
      answer: "Bien au contraire, nous agissons en complément et conjointement à votre équipe commerciale. Nous prenons en charge la prospection et la qualification des leads pour que vos commerciaux puissent se concentrer sur ce qu'ils font le mieux : conclure des affaires, closer des deals. Vos commerciaux vont nous adorer !"
    },
    {
      question: "Comment Prosperian s'intègre-t-il à mon CRM existant ?",
      answer: "Notre solution est compatible avec la plupart des CRM du marché (Salesforce, HubSpot, Pipedrive, etc.). Nous nous chargeons de l'intégration technique et de la configuration pour une synchronisation parfaite des données."
    },
    {
      question: "Quels secteurs d'activité peuvent bénéficier de vos services ?",
      answer: "Nous nous spécialisons dans le B2B, particulièrement dans l'industrie, les services financiers, la formation, l'équipement, la logistique/transport, les solutions professionnelles, la technologie et les logiciels."
    },
    {
      question: "Comment mesurez-vous les résultats de vos campagnes ?",
      answer: "Nous définissons ensemble des KPIs précis en fonction de vos objectifs commerciaux. Notre dashboard vous permet de suivre en temps réel le nombre de leads générés, leur qualité, les taux de conversion et le ROI global de vos campagnes."
    },
    {
      question: "Utilisez-vous l'intelligence artificielle dans votre approche ?",
      answer: "Oui, nous utilisons l'IA et nos solutions propriétaires pour optimiser le ciblage, personnaliser les messages à grande échelle et analyser les performances des campagnes. Cependant, nous combinons toujours cette technologie avec l'expertise humaine de nos spécialistes."
    },
    {
      question: "Quelle est la structure tarifaire de Prosperian ?",
      answer: "Notre tarification se fonde sur un abonnement mensuel qui inclut l'accès à notre suite technologique, à votre dashboard et à notre collectif d'experts. Le montant varie en fonction de votre score, de la complexité de votre marché et du niveau d'accompagnement souhaité."
    },
    {
      question: "Combien de temps faut-il pour voir les premiers résultats ?",
      answer: "Les premiers indicateurs d'amélioration sont généralement visibles à l'issue du premier mois. Des résultats significatifs en termes de pipeline commercial se manifestent habituellement entre 2 et 3 mois."
    },
    {
      question: "Est-ce que vous garantissez un nombre minimum de leads ou de rendez-vous ?",
      answer: "Nous définissons ensemble des objectifs réalistes basés sur votre secteur et votre offre. Nous nous engageons sur des KPIs précis et travaillons en transparence totale pour les atteindre."
    },
    {
      question: "Qui seront mes interlocuteurs chez Prosperian ?",
      answer: "Vous bénéficiez d'un attaché de compte dédié qui coordonne l'ensemble de vos campagnes et fait le lien avec notre collectif d'experts spécialisés par levier d'acquisition."
    },
    {
      question: "Puis-je choisir les canaux de prospection que je souhaite privilégier ?",
      answer: "Notre approche commence par une analyse objective pour identifier les leviers les plus pertinents pour votre activité. Nous vous recommandons une combinaison optimale, mais restons à l'écoute de vos préférences."
    },
    {
      question: "Comment formez-vous votre collectif d'experts ?",
      answer: "Chaque expert de notre collectif est sélectionné pour son expertise pointue dans un domaine spécifique (LinkedIn, emailing, webinaires, copywriting, etc.) et bénéficie d'une formation continue sur nos méthodes et outils. Notre comité de sélection coopte régulièrement de nouveaux intervenants qui doivent démontrer un savoir-faire d'excellence et une écoute attentive du besoin client."
    },
    {
      question: "Que se passe-t-il si je ne suis pas satisfait des résultats ?",
      answer: "Nous travaillons avec une approche basée sur la transparence et l'amélioration continue. Si les résultats ne sont pas au rendez-vous, nous révisons la stratégie et ajustons les campagnes sans frais supplémentaires."
    },
    {
      question: "Quelles typologies de clients et d'entreprises accompagnez-vous ?",
      answer: "Nous travaillons principalement avec des PME établies qui disposent déjà d'une offre éprouvée et d'une première base clients, mais aussi avec les filiales françaises de groupes étrangers. Nous pouvons actionner des campagnes pour des TPE et consultants (de types cabinets de conseil, boutiques M&A, coachs, formateurs...) visant une prospection B2B. Nous accompagnons parfois des scale-ups en phase d'hyper croissance, en France et sur des marchés à l'international. Pour les startups en phase très précoce, nous proposons un programme spécifique adapté à leurs enjeux."
    },
    {
      question: "Comment gérez-vous la confidentialité et la protection des données ?",
      answer: "Nous respectons scrupuleusement le RGPD et mettons en place des processus sécurisés pour la gestion de vos données. Tous nos contrats incluent des clauses strictes de confidentialité."
    },
    {
      question: "Puis-je accéder à mon dashboard Prosperian depuis un mobile ?",
      answer: "Oui, notre interface est entièrement responsive et accessible depuis n'importe quel appareil, vous permettant de suivre vos campagnes même en déplacement."
    },
    {
      question: "Comment se déroule l'onboarding au programme Prosperian ?",
      answer: "Après validation de votre éligibilité, nous organisons un workshop initial avec vous (et vos équipes le cas échéant) pour analyser votre existant, définir vos objectifs et configurer votre dashboard. Les premières campagnes sont généralement lancées dans les 2 semaines suivantes."
    },
    {
      question: "Quelles sont les ressources nécessaires de notre côté pour collaborer efficacement ?",
      answer: "Pour une collaboration optimale, nous demandons un point de contact dédié dans votre entreprise qui consacrera environ 2 heures par semaine aux échanges avec votre attaché de compte Prosperian."
    }
  ];

  const toggleQuestion = (index) => {
    if (openQuestion === index) {
      setOpenQuestion(null);
    } else {
      setOpenQuestion(index);
    }
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h1 className="faq-title">Questions fréquentes</h1>
          <p className="faq-intro">
            Tout ce que vous devez savoir sur notre approche et notre méthodologie
          </p>
        </div>

        <div className="faq-content">
          <div className="faq-questions">
            {faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${openQuestion === index ? 'open' : ''}`}>
                <div className="faq-question" onClick={() => toggleQuestion(index)}>
                  <h3>{faq.question}</h3>
                  <span className="faq-icon">{openQuestion === index ? '−' : '+'}</span>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="faq-cta">
        <div className="faq-container">
          <h2 className="cta-title">TESTEZ VOTRE ÉLIGIBILITÉ AU PROGRAMME PROSPERIAN</h2>
          <p className="cta-description">
            Découvrez comment notre approche peut transformer votre stratégie de génération de leads B2B.
          </p>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
            <button className="cta-button">OBTENIR MON SCORE</button>
          </a>
        </div>
      </div>

      <div className="faq-cta secondary">
        <div className="faq-container">
          <h2 className="cta-title">Besoin de plus d'informations ?</h2>
          <p className="cta-description">
            Contactez-nous pour découvrir comment notre méthodologie peut s'adapter à vos enjeux spécifiques.
          </p>
          <div className="cta-buttons">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="cta-button">Demander une démo</button>
            </a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
              <button className="cta-button secondary">Tester mon éligibilité</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ; 